import { Helmet } from 'react-helmet-async';

export default function SEO({ 
  title, 
  description, 
  keywords,
  canonicalUrl,
  ogImage = 'https://www.skandaitsolutions.com/skanda-logo.png',
  ogType = 'website',
  noindex = false
}) {
  const siteName = 'SKANDA IT SOLUTIONS';
  const defaultTitle = 'SKANDA IT SOLUTIONS | Best IT Training Institute in Narasaraopeta';
  const defaultDescription = 'SKANDA IT SOLUTIONS is the leading IT training institute in Narasaraopeta, Andhra Pradesh. We offer courses in Full Stack Web Development, AWS Cloud, Data Science with 100% placement assistance.';
  const defaultKeywords = 'IT training Narasaraopeta, computer courses, web development, AWS training, Data Science, Python, placement assistance, SKANDA IT SOLUTIONS';

  const seoTitle = title ? `${title} | ${siteName}` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoCanonical = canonicalUrl || 'https://www.skandaitsolutions.com';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <link rel="canonical" href={seoCanonical} />
      
      {/* Robots Meta Tag - Critical for Indexing */}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'} />
      <meta name="googlebot" content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'} />
      <meta name="bingbot" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      
      {/* Prevent redirect interpretation */}
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={seoCanonical} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seoCanonical} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
